import Loadable from 'react-loadable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import leadActions from '@/redux/lead/actions';
import sidebarActions from '@/redux/sidebar/actions';
import proposalActions from '@/redux/proposals/actions';
import modalsActions from '@/redux/modals/actions';
import formActions from '@/redux/intakeForm/actions';
import quotesActions from '@/redux/quotes/actions';
import { Loader } from '@/components';

const AsyncLead = Loadable({
  loader: () => import('./Lead'),
  loading: Loader,
});

const mapStateToProps = ({ lead, auth, proposals, quotes }, ownProps) => {
  const { id: leadId } = ownProps.match.params;

  return {
    lead,
    leadId,
    proposals,
    isAdminRole: auth.permissions.isAdminRole,
    marketingPrevalidateData:
      proposals.marketingPrevalidateData?.leadId === Number(leadId) ? proposals.marketingPrevalidateData : null,
    quotesPrevalidateData:
      quotes.quotesPrevalidateData?.leadId === Number(leadId) ? quotes.quotesPrevalidateData : null,
    organizations: auth.organizations,
    superAdmin: auth.permissions.superAdmin,
    orgAdmin: auth.permissions.orgAdmin,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchLead: leadActions.fetchLead,
      updateLead: leadActions.updateLead,
      changeTab: leadActions.changeTab,
      deleteLead: leadActions.deleteLead,
      setEditMode: leadActions.setEditMode,
      deleteFile: leadActions.deleteFile,
      changeLayoutCollapsed: sidebarActions.changeLayoutCollapsed,
      saveEditData: leadActions.saveEditData,
      clearEditData: leadActions.clearEditData,
      fillLeadFields: leadActions.fillLeadFields,
      createProposal: proposalActions.createProposal,
      removeMarketingPrevalidateMessage: proposalActions.removeMarketingPrevalidateMessage,
      removeQuotesPrevalidateMessage: quotesActions.removeQuotesPrevalidateMessage,
      toggleUAPIIframeModal: modalsActions.toggleUapiIframeModal,
      utilityApiAuth: formActions.utilityApiAuth,
      resetDocumentUrl: leadActions.resetDocumentUrl,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncLead);
